import { render, staticRenderFns } from "./WidgetDocumentInformations.vue?vue&type=template&id=a404b572&scoped=true&"
import script from "./WidgetDocumentInformations.vue?vue&type=script&lang=js&"
export * from "./WidgetDocumentInformations.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDocumentInformations.vue?vue&type=style&index=0&id=a404b572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a404b572",
  null
  
)

export default component.exports